import PropTypes from 'prop-types';
export default function TimeWindow(_ref) {
  var start = _ref.start,
      end = _ref.end,
      component = _ref.component,
      children = _ref.children;
  var now = Date.now();
  var isAfterStart = new Date(start).getTime() < now;
  var isBeforeEnd = now < new Date(end).getTime();
  var inInterval = (!start && end || isAfterStart) && (start && !end || isBeforeEnd);

  if (inInterval) {
    return component;
  }

  return children;
}
var TimestampPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
TimeWindow.propTypes = {
  start: TimestampPropType,
  end: TimestampPropType
};
TimeWindow.defaultProps = {
  intervals: []
};